<div class="order-confirm-wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
  <div class="lines-details">
    <span class="item">Line: {{selectedMdn | mask: '000.000.0000' }}</span>
    <span class="item">Your Order has been submitted and you will receive the order confirmation details in an email.</span>
  </div>
  <div class="main-details-box">
    <h4 class="title">
      Please note that your connectivity will not work unless your activation is complete.
    </h4>
    <p class="text-block">
      Please note that your connectivity will not work unless the step above is complete. Please call 1-800-922-0204 if you have any questions.
You will receive confirmation and overview of your account changes in an email notification once the activation is complete. </p>
  </div>
  <div class="confirmation-info-box">
    <div class="bottom-text-block">
      <p>
        Charges may apply for additional paired vehicles
        <a style="color: black; cursor: pointer;" href="https://www.verizon.com/support/surcharges/" class="link" target="_blank">https://www.verizon.com/support/surcharges/</a>
      </p>
    </div>
  </div>
  <div class="button-box">
    <app-main-button
        (onClick)="onBackToOem()"
        [buttonWidth]="'92vw'"
        [border]="'1px solid #000000'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'#000000'"
        [buttonText]="'Return to vehicle\'s mobile app'">
    </app-main-button>
</div>
</div>
